import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "overrideFields",
    "submitButton",
    "freeToggle",
    "freeOverrideInput",
    "standardPricing",
  ];
  static values = { hasPaymentMethod: Boolean, stripeConnected: Boolean };

  connect() {
    this.applyFreeState();
    this.toggleOverrideFields();
    this.updateSubmitState();
  }

  toggle() {
    this.applyFreeState();
    this.toggleOverrideFields();
    this.updateSubmitState();
  }

  applyFreeState() {
    const free = this.isFree();

    if (this.hasFreeOverrideInputTarget) {
      this.freeOverrideInputTarget.disabled = !free;
    }

    if (this.hasStandardPricingTarget) {
      this.standardPricingTarget.disabled = free;
      this.standardPricingTarget.classList.toggle("opacity-50", free);
      this.standardPricingTarget.classList.toggle("pointer-events-none", free);
    }
  }

  toggleOverrideFields() {
    if (!this.hasOverrideFieldsTarget) return;
    if (this.isFree()) {
      this.overrideFieldsTarget.classList.add("hidden");
      return;
    }

    const checkbox = this.element.querySelector(
      'input[type="checkbox"][name*="override_price"]'
    );
    const checked = checkbox?.checked ?? false;
    this.overrideFieldsTarget.classList.toggle("hidden", !checked);
  }

  updateSubmitState() {
    if (!this.hasSubmitButtonTarget) return;
    const blocked =
      this.stripeConnectedValue && !this.hasPaymentMethodValue && !this.isFree();
    this.submitButtonTarget.disabled = blocked;
  }

  isFree() {
    return this.hasFreeToggleTarget && this.freeToggleTarget.checked;
  }
}
